var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-bar"},[(_vm.spinning)?_c('a-spin',{attrs:{"tip":"Loading..."}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }